import r from"vue";export{default as Vue}from"vue";var t=!0,e=!1,u=r,n=r.version;function o(r){return function(t){return r.call(this,t)}}function f(r){return r.$slots.default}export{u as Vue2,f as getDefaultSlot,t as isVue2,e as isVue3,o as renderCompat,n as version};
//# sourceMappingURL=index-2.js.map
